export class ResponseWithCacheInfo<TResponse> {

    response: TResponse;
    cache: {
        timestamp: number;
    }
}
